import { useActivePromoCoupon, useBestActivePromotionForPlan } from '../../../hooks/use-coupon';

export const useIsAcceptingPromotion = (newPlanCode: string): boolean => {
  const bestActivePromo = useBestActivePromotionForPlan(newPlanCode);
  const activePromoCoupon = useActivePromoCoupon();

  if (bestActivePromo) {
    return true;
  }

  if (!activePromoCoupon) {
    return false;
  }

  if (activePromoCoupon.applicablePlanCodes.length === 0) {
    return true;
  }

  return activePromoCoupon.applicablePlanCodes.some((code) => code.toLowerCase() === newPlanCode.toLowerCase());
};
